export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9985.8f50a669.jpg";